<div id="content-desktop">
  <header>


    <div class="container">
      <br />
      <div class="row">
        <div class="col-md-12">
          <span style="padding-top: 1%; padding-bottom: 1%; width: 10% " class="img-responsive">
            <img src="../../../assets/D URL 2.png" style="width: 40%; position: absolute; top: 25%; " class="img-responsive" />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<img src="../../../assets/D Beef Phone.png" style="width: 15%; display: block; margin-left: auto; top: 50%;" class="right" />
          </span>
        </div>
      </div>
    </div>
    <br />
    <nav class="navbar navbar-expand-sm navbar-toggleable-sm navbar-light  border-bottom " style="background-color: #d64038 ">
      <div class="container">
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target=".navbar-collapse" aria-label="Toggle navigation" [attr.aria-expanded]="isExpanded" (click)="toggle()">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="navbar-collapse collapse d-sm-inline-flex flex-sm-row-reverse justify-content-center" [ngClass]="{ show: isExpanded }">
          <ul class="navbar-nav flex-grow">
            <li class="nav-item" [routerLinkActive]="['link-active']" [routerLinkActiveOptions]="{ exact: true }">
              <a class="nav-link  hover_lightBlue" [routerLink]="['/home']" style="color: white; font-weight: bold ">Home</a>
            </li>
            <li class="nav-item" [routerLinkActive]="['link-active']">
              <a class="nav-link hover_lightBlue" [routerLink]="['/notice']" style="color: white; font-weight: bold">Notice/FAQs</a>
            </li>
            <li class="nav-item" [routerLinkActive]="['link-active']">
              <a class="nav-link hover_lightBlue" [routerLink]="['/login']" style="color:white; font-weight: bold ">File A Claim</a>
            </li>
            <li class="nav-item" [routerLinkActive]="['link-active']">
              <a class="nav-link hover_lightBlue" [routerLink]="['/court-documents']" style="color:white; font-weight: bold ">Court Documents</a>
            </li>
            <li class="nav-item" [routerLinkActive]="['link-active']">
              <a class="nav-link hover_lightBlue" [routerLink]="['/contact-information']" style="color:white; font-weight: bold ">Contact Information</a>
            </li>
          </ul>
        </div>
      </div>

    </nav>


  </header>
</div>


<div class="container" style="border:1px solid #bebaba">

  <div class="text-center" style="font-weight:bold">

    <br />

    This official website is maintained by the Claims Administrator under the supervision of Co-Lead Counsel for the members of the
    Settlement Class in In re Cattle and Beef Antitrust Litigation, et al., Case No. 20-cv-01319 JRT-HB (the “Settlement”), which is
    pending in the United States District Court for the District of Minnesota.
    <br />
    <br />
  </div>
  <div class="row">
    <div class="col-md-12">

      <a [routerLink]="['/login']">
        <img src="../../../assets/D Case Name.png" class="img-responsive" style="width:100%; display: block; margin: 0 auto; width: 100%;">
      </a>
      <a [routerLink]="['/login']">
        <img src="../../../assets/BD File button.png" class="img-responsive" style="width:20%; display: block; margin: 0 auto; width: 20%;">
      </a>
      <a [routerLink]="['/login']">
        <img src="../../../assets/D Beef Direct.png" class="img-responsive" style="width:100%; display: block; margin: 0 auto; width: 100%;">
      </a>
      <div class="panel-heading" style="background-color: #d64038; color: white; text-align: center;  font-weight: bold ">
        <br />
        <h3>
          What is this Lawsuit About?
        </h3>
        <br />
      </div>



    </div>
  </div>
  <br /><br />
  <div class="row">
    <div class="col-md-12" style=" text-align: justify; ">
      <p style="text-align: center; font-weight: bold;">
        The information on this website is only a summary of the terms of the Settlement. For more detailed information, please review
        the Long Form Notice and/or the Settlement Agreement.
      </p>
      A new Settlement Agreement has been reached in a class action antitrust lawsuit filed on behalf of Direct Purchaser Plaintiffs
      with Tyson Foods, Inc. and Tyson Fresh Meats, Inc. (collectively, “Tyson”). This Settlement only applies to Tyson and does not
      affect claims against other Defendants in the case. Tyson has agreed to pay $82.5 million to resolve the claims in this lawsuit.
      In addition, Tyson has agreed to provide specified cooperation in the Direct Purchaser Plaintiffs in their continued prosecution
      of the litigation.<br /><br />

      Generally, you are included in the Settlement if, from January 1, 2015, through February 29, 2020, you purchased directly from
      any of the Defendants or their respective subsidiaries and affiliates, whether fresh or frozen, Beef product made from chuck,
      loin, rib, or round. Any product that is marketed as organic, grass-fed, kosher, halal, certified humane, Wagyu, “American-Style
      Kobe Beef,” and any product that is cooked, marinated, seasoned, flavored, or breaded are excluded from this Settlement.<br /><br />

      All persons and entities who directly purchased Beef for use or delivery in the United States, whether fresh or frozen, made from
      one of the following primals: chuck, loin, rib, or round from Defendants, or their respective subsidiaries or affiliates, from
      January 1, 2015, to February 29, 2020. For this lawsuit, beef excludes any product that is marketed as organic, grass-fed, kosher,
      halal, certified humane, Wagyu, “American-Style Kobe Beef,” and any product that is cooked, marinated, seasoned, flavored,
      or breaded.<br /><br />

      While this Settlement is only with Tyson, the Settlement Class includes persons or entities that purchased boxed or case-ready beef
      from any of the Defendants.<br /><br />

      The Court has not decided whether Tyson did anything wrong, and Tyson denies any wrongdoing.<br /><br />

      <span style="font-weight:bold; text-decoration:underline; font-size:1.3em">JBS Settlement</span><br /><br />

      The settlement with JBS was approved by the Court. The Court previously granted final approval of the JBS Settlement Agreement
      and found that due and adequate notice of the Settlement was provided to the Class. The Court granted final approval of the JBS
      Settlement on August 31, 2022. The JBS Defendants have paid a total of $52,500,000.00 into the Settlement Fund.<br /><br />

      Settlement funds were distributed in July, 2026.
      <br /><br />

      <span style="font-weight:bold; text-decoration:underline; font-size:1.3em">Tyson Settlement</span><br /><br />

      The deadline to Object and Opt Out has been extended to October 23, 2026.

    </div>
  </div>


  <div class="row" style="margin-left:5%;margin-right:5%; margin-top:5%">
    <div class="col-md-12">
      <div class="table-responsive">
        <table class="table table-bordered">
          <thead>
            <tr>
              <th colspan="2" style="background-color: #d64038; color: white; font-weight: bold; font-size: 1.2em; text-align: center;">
                YOUR LEGAL RIGHTS AND OPTIONS FOR THE SETTLEMENT
              </th>

            </tr>

          </thead>
          <tbody>
            <tr>
              <td style="background-color: #D3D3D3; text-align: center; font-weight: bold; color: #000000; vertical-align: middle; width: 25% ">
                FILE A CLAIM TO RECEIVE MONEY FROM THE SETTLEMENT
              </td>
              <td style="background-color:white; color:#3e4144; width:50%">
                To receive money from the Settlement you must submit a Claim Form by <b>November 30, 2026</b>.
                If you are a Settlement Class Member who files a valid Claim Form, you will be eligible to
                receive a payment from the Settlement.<br /><br />

                If you already filed a claim in the previous settlement, you <b><u>do not</u></b> need to
                submit another claim. You will automatically be eligible to receive a payment from this
                Settlement.<br /><br />

                Instructions on how to file a claim are available in Question 12 of this Notice, on the
                Claim Form, and at the Settlement Website, www.BeefDirectPurchaserSettlement.com.
              </td>

            </tr>
            <tr>
              <td style="background-color: #D3D3D3; text-align: center; font-weight: bold; color: #000000; vertical-align: middle; width: 25% ">
                ASK TO BE EXCLUDED
              </td>
              <td style="background-color:white; color:#3e4144; width:50%">
                This is the only option that allows you to be part of any <b><i>other</i></b> lawsuit against
                Tyson concerning the Released Claims (as defined in the Settlement Agreement). You will not be
                included in this Settlement. You will receive no benefits from the Settlement, but you will
                keep any rights you currently have to sue Tyson about the claims in the lawsuit. Requests for
                Exclusion must be postmarked or received by <b>October 23, 2026</b>.
              </td>
            </tr>
            <tr>
              <td style="background-color: #D3D3D3; text-align: center; font-weight: bold; color: #000000; vertical-align: middle; width: 25% ">
                OBJECT
              </td>
              <td style="background-color:white; color:#3e4144; width:50%">
                If you do not exclude yourself, you may object to the Settlement. Objections must be postmarked
                or received by <b>October 23, 2026</b>.
              </td>

            </tr>
            <tr>
              <td style="background-color: #D3D3D3; text-align: center; font-weight: bold; color: #000000; vertical-align: middle; width: 25% ">
                ATTEND THE<br />
                FAIRNESS HEARING
              </td>
              <td style="background-color:white; color:#3e4144; width:50%">
                You may ask to speak in Court about the fairness of the Settlement.
              </td>

            </tr>
            <tr>
              <td style="background-color: #D3D3D3; text-align: center; font-weight: bold; color: #000000; vertical-align: middle; width: 25% ">
                DO NOTHING
              </td>
              <td style="background-color:white; color:#3e4144; width:50%">
                If you do nothing, you will remain part of the Settlement.<br /><br />

                If you already filed a claim in the previous settlement and do nothing, you may get a payment.
                If you did not already file a claim and do nothing now, you will not get a payment from this
                Settlement.<br /><br />

                The Settlement will resolve your claims against Tyson, and you will give up your rights to sue
                Tyson about the Released Claims (as defined in the Settlement Agreement). You will be bound by
                the judgment.
              </td>

            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <br /><br />

  <div class="row">
    <div class="col-md-12" style=" text-align: justify; ">
      <span style="font-weight:bold; text-decoration:underline; font-size:1.3em">Class Definition—You May Be Part of the Class </span><br /><br />

      The Court decided that, for settlement purposes, the Settlement Class for the Tyson Settlement is defined as:<br /><br />

      All persons and entities who directly purchased Beef for use or delivery in the United States, whether fresh or frozen,
      made from one of the following primals: chuck, loin, rib, or round from Defendants, or their respective subsidiaries or
      affiliates, from January 1, 2015, to February 29, 2020. For this lawsuit, beef excludes any product that is marketed as
      organic, grass-fed, kosher, halal, certified humane, Wagyu, “American-Style Kobe Beef,” and any product that is cooked,
      marinated, seasoned, flavored, or breaded.<br /><br />

      <span style="font-weight:bold; text-decoration:underline; font-size:1.3em">The Settlement Benefits</span><br /><br />
      If the Settlement is approved, Tyson will pay $80,000,000 to resolve all Settlement Class members’ claims against Tyson for the Released Claims (as defined in the
      Settlement Agreement) in addition to $2,500,000 for settlement notice and administrative costs. In addition to this monetary benefit, Tyson has also agreed to provide
      specified cooperation in the Direct Purchaser Plaintiffs’ continued prosecution of the litigation.<br /><br />

      The Settlement Proceeds will be used to pay:

      <ul>
        <li>
          Notice and claims administration costs;
        </li>
        <li>
          Attorney’s fees up to 33-1/3% of the Settlement Proceeds;
        </li>
        <li>
          Incurred litigation costs not to exceed $1.5 million;
        </li>
        <li>
          Service awards up to $25,000 for each of the three class representatives;
        </li>
        <li>
          Future litigation costs of $5 million; and
        </li>
        <li>
          Payments to eligible Settlement Class Members.
        </li>
      </ul>

      The Court already approved the settlement with JBS totaling $52,500,000. Together, the JBS and Tyson Settlement Funds total $135,000,000.<br /><br />

      Plaintiffs and Co-Lead Counsel will file a motion or motions by October 1, 2026, in which they will seek attorneys’ fees, incurred litigation costs, service awards for
      each of the Plaintiffs who are serving as class representatives, and future litigation costs. A copy of the motion(s) will be available on the Settlement Website.<br /><br />

      <span style="font-weight:bold; text-decoration:underline; font-size:1.3em">How to Get a Payment</span><br /><br />

      To receive a payment from the Settlement, you must complete and submit a Claim Form by <b>November 30, 2026</b>.<br /><br />

      <span style="font-weight:bold; text-decoration:underline; font-size:1.3em">The Hearing</span><br /><br />

      <p style="font-weight:bold;color:red">ATTENTION - READ <a href="../../../assets/documents/courtdocs/0_22-md-03031-JRT-JFD_1667_PRIMARY DOCUMENT.pdf" target="_blank">THIS</a> IMMEDIATELY</p>

      The Court will hold a hearing to decide whether to approve the Settlement (the “Fairness Hearing”). You may attend
      and you may ask to speak, but you don’t have to. The Court is currently scheduled to hold the Fairness Hearing on
      November 12, 2026, at the United States District Court for the District of Minnesota, Courtroom 15, 300 South Fourth
      Street, Minneapolis, MN 55415.<br /><br />

      <span style="font-weight:bold; text-decoration:underline; font-size:1.3em">Further Information</span><br /><br />

      This website and the Notice summarize the Settlement. For more details regarding this Settlement, please reference
      the Settlement Agreement or other documents filed in the case under the “Court Documents” link above. You may also
      contact the Claims Administrator for further information regarding this Settlement.<br /><br />

      <p style="text-align:center">

        <b>Claims Administrator:</b><br />
        DPP Beef Litigation<br />
        c/o A.B. Data, Ltd.<br />
        P.O. Box 173066<br />
        Milwaukee, WI  53217<br />
        877-331-0717<br />
        <a href="mailto:info@BeefDirectPurchaserSettlement.com">info@BeefDirectPurchaserSettlement.com</a><br /><br />

        If you have questions, you may call the DPP Beef Litigation Helpline at 877-331-0717 or email
        <a href="mailto:info@BeefDirectPurchaserSettlement.com">info@BeefDirectPurchaserSettlement.com</a>.
      </p>

    </div>
  </div>
  <br />
  <br />
















</div>








